import { $fontSize, $height, $marginTop, $width, phoneSize } from '@/assets/styles/mediaSize';
import { flexPos, overDots } from '@/assets/styles/mixin';
import { FC } from 'react';
import { styled } from 'styled-components';
import useAppStore from '@/store/appStore';
import Image from '@/components/MediaComp/Image';

export interface IKnowledge {
  id: string;
  language: string;
  knowledgeBaseName: string;
  url: string;
}

interface IRobotSortOneProps {
  onClick?: () => void;
  knowledgeItem: IKnowledge;
}

const RobotSortOneItemWrap = styled.div<{ $width: string }>`
  width: ${(props) => props.$width};
  height: ${(props) => props.$width};
  flex: 0 0 ${(props) => props.$width};
  padding: 5rem;

  cursor: pointer;
  background-color: #f3f4f6;

  ${flexPos('center')}
  flex-direction: column;

  /* &:not(:first-child) {
    margin-left: 16rem;
  } */

  border-radius: 16rem;
  @media (min-width: ${phoneSize}) {
    border-radius: 0 12rem 12rem 12rem;
  }

  .sort-content {
    border-radius: 16rem;
    ${flexPos('center')}

    .image-wrap {
      ${$width('48rem', '32rem')}
      ${$height('48rem', '32rem')}
    }
  }

  .knowledge-text {
    color: #000;
    ${$fontSize('24rem', '12rem')}
    ${$marginTop('4rem', '4rem')}
    ${overDots(2)}
    text-align: center;
  }
`;

const RobotSortOneItem: FC<IRobotSortOneProps> = (props) => {
  const appStore = useAppStore();

  const showLogo = useMemo(() => {
    return props.knowledgeItem.url || require('@img/common/icon-default-robot-question.png');
  }, [props.knowledgeItem.url]);

  return (
    <RobotSortOneItemWrap
      onClick={() => props.onClick?.()}
      $width={appStore.curDevice === 'phone' ? '152rem' : '102rem'}
    >
      <div className="sort-content">
        <div className="image-wrap">
          <Image src={showLogo} className="w-full h-full object-cover" />
        </div>
      </div>

      <div className="knowledge-text">{props.knowledgeItem.knowledgeBaseName}</div>
    </RobotSortOneItemWrap>
  );
};

export default RobotSortOneItem;
